<!-- Container-fluid starts-->
<div class="container-fluid">
    
</div>
<!-- Container-fluid Ends-->